import { CurrencyPipe, DatePipe, TitleCasePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, enableProdMode, ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { OAuthModule } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginModule } from './features/login/login.module';
import { LoggingInterceptor } from './interceptors/logging.interceptor';
import { ServicesModule } from './services/services.module';
import { UXModule } from './shared/ux/ux.module';
import { rootMetaReducers, rootReducers } from './state/reducers';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDrawerWrapperComponent } from './shared/mat-drawer/mat-drawer.component';
import { fareRulesFeatureKey } from './features/fare-rules/state/fare-rules.state';
import { fareRulesReducer } from './features/fare-rules/state/fare-rules.reducer';
import { MatDialogModule } from '@angular/material/dialog';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';
import { MatDateAdapter } from './shared/mat-date-time-adapter/mat-datetime.adapter';
import { enUS } from 'date-fns/locale';
import { GlobalErrorHandler } from './services/logger-service/global-error.handler';
import { ErrorBootstrapService } from './services/logger-service/error-bootstrap.service';

if (environment.production) {
  enableProdMode();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MatSidenavModule,
    // RAIN Modules (Note - do NOT include lazy-loaded routed feature modules here)
    AppRoutingModule.forRoot(),
    LoginModule,
    ServicesModule.forRoot(),
    UXModule,
    MatDialogModule,
    OAuthModule.forRoot(),
    StoreModule.forRoot(rootReducers, {
      metaReducers: rootMetaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictStateSerializability: true,
        strictActionSerializability: true,
      },
    }),
    StoreModule.forFeature(fareRulesFeatureKey, fareRulesReducer),
    StoreDevtoolsModule.instrument({
      name: 'RAIN DevTools',
      maxAge: 25,
      logOnly: environment.production,
    }),
    EffectsModule.forRoot(),
    MatDrawerWrapperComponent,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    DatePipe,
    TitleCasePipe,
    CurrencyPipe,
    { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
    { provide: MAT_DATE_LOCALE, useValue: enUS }, // Use your desired locale
    { provide: DateAdapter, useClass: MatDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideAppInitializer(() => {
      inject(ErrorBootstrapService);
    }),
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
